import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import 'react-datepicker/dist/react-datepicker.css';

export default class MDatePicker extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			startDate: moment(),
			endDate: moment(),
			selectStartDate: true,
		};

		this.bindHandles();
	}

	bindHandles() {
		this.handleChangeStart = this.handleChangeStart.bind(this);
	}

	handleChangeStart(date) {
		let startDate;
		let endDate;
		let valid = false;

		if (this.state.selectStartDate) {
			startDate = date;
			endDate = this.state.endDate;
		} else {
			startDate = this.state.startDate;
			endDate = date;
			valid = true;
		}

		this.setState({ startDate, endDate, selectStartDate: true });

		if (this.props.onChange) {
			this.props.onChange({
				value: {
					startDate,
					endDate,
				},
				valid,
			});
		}
	}

	render() {
		return (
			<article className={`m-date-picker ${this.props.className}`}>
				<label>
					<FormattedMessage id="RENT_POP_UP.SELECT_DATE" defaultMessage="" />
				</label>
				<DatePicker
					inline
					selectsStart
					selected={this.state.startDate}
					startDate={this.state.startDate}
					endDate={this.state.endDate}
					onChange={this.handleChangeStart}
				/>
			</article>
		);
	}
}

MDatePicker.propTypes = {
	onChange: PropTypes.func,
	className: PropTypes.string,
};

MDatePicker.defaultProps = {
	onChange: undefined,
	className: '',
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.date-picker.js